"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable max-len */
/* eslint-disable consistent-return */
const react_1 = require("react");
const ton_1 = require("ton");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const de_ui_1 = require("@delab-team/de-ui");
const core_1 = require("@ton/core");
const react_i18next_1 = require("react-i18next");
const svg_selector_1 = require("../../../../assets/svg-selector");
const smlAddr_1 = require("../../../../helpers/smlAddr");
const tonapi_1 = require("../../../../logic/tonapi");
const checkout_module_css_1 = __importDefault(require("./checkout.module.css"));
const pinpad_1 = require("../../../../components/pinpad");
const wallet_1 = require("../../../../logic/wallet");
const getClient_1 = require("../../../../utils/getClient");
const Checkout = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [createAnimation, setCreateAnimation] = (0, react_1.useState)(undefined);
    const wall = new wallet_1.CustomWallet((0, getClient_1.getDeLabClient)());
    const [amountUsd, setAmountUsd] = (0, react_1.useState)(undefined);
    const TgObj = sdk_1.default;
    const fee = (0, ton_1.fromNano)((0, core_1.toNano)('0.001') + (0, core_1.toNano)('0.03'));
    const feeToken = props.sendData.token === 'TON' ? Number(fee) : Number((0, ton_1.fromNano)((0, core_1.toNano)('0.2')));
    const tonapi = new tonapi_1.TonApi();
    const tonBalanceTon = parseFloat(props?.walletBalanceTON?.replace(',', '.') ?? '0') / (props?.priceTON ?? 2); // usd
    function enableBtn() {
        TgObj.MainButton.enable();
        TgObj.MainButton.show();
        if (tonBalanceTon < feeToken) {
            TgObj.MainButton.text = t('common.fee-is-to-high');
            TgObj.MainButton.disable();
            TgObj.MainButton.color = '#424B56';
        }
        else if (!props.isSubmited) {
            TgObj.MainButton.color = '#007AFF';
            TgObj.MainButton.text = t('common.submit');
            TgObj.MainButton.enable();
        }
        else if ((props.isSubmited && props.isSended)
            || props.psw.value.length < 8
            || props.psw.iserr !== 'valid') {
            TgObj.MainButton.text = t('swap-modal.sending-loading');
            TgObj.MainButton.color = '#424B56';
            TgObj.MainButton.disable();
        }
        //  else {
        //     TgObj.MainButton.color = '#007AFF'
        //     TgObj.MainButton.text = t('main.send-btn2')
        //     TgObj.MainButton.enable()
        // }
    }
    const handleSend = async () => {
        const checkPsw = await wall.getPrivateKey(props.psw.value);
        if (typeof checkPsw === 'object') {
            setCreateAnimation('failure');
            return;
        }
        setCreateAnimation('success');
        TgObj.MainButton.showProgress();
        await props.transMakeToCompl();
    };
    (0, react_1.useEffect)(() => {
        if (props.psw.value.length === 4) {
            handleSend();
        }
    }, [props.psw.value.length, props.psw.value]);
    (0, react_1.useEffect)(() => {
        if (props.position !== 3)
            return;
        enableBtn();
        const handleBtnClick = () => {
            if (!props.isSubmited) {
                props.setIsSubmited(true);
            }
        };
        TgObj.MainButton.onClick(handleBtnClick);
        return () => {
            TgObj.MainButton.offClick(handleBtnClick);
        };
    }, [props.position === 3, props.psw.value, props.isSended, props.isSubmited]);
    (0, react_1.useEffect)(() => {
        const getAmountUSD = async () => {
            try {
                const res = await tonapi.getTokenPrice(props.sendData.tokenAddress, 'usd');
                if (res) {
                    const firstRateKey = Object.keys(res.rates)[0];
                    const firstRate = res.rates[firstRateKey];
                    setAmountUsd(firstRate.prices.USD);
                }
            }
            catch (error) {
                console.error(error);
            }
        };
        getAmountUSD();
    }, [props.position === 3, props.sendData.amount]);
    return ((0, jsx_runtime_1.jsx)("div", { className: checkout_module_css_1.default.container, children: !props.isSubmited ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: checkout_module_css_1.default.modalTitle, children: t('send.checkout') }), (0, jsx_runtime_1.jsxs)("div", { className: checkout_module_css_1.default.top, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: checkout_module_css_1.default.youSend, children: t('trans-detail.you-send') }), (0, jsx_runtime_1.jsxs)("div", { className: checkout_module_css_1.default.topAmountWrapper, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: checkout_module_css_1.default.topAmount, children: props.sendData.amount }), (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: checkout_module_css_1.default.topAmountToken, children: props.sendData.token })] }), amountUsd && amountUsd.length !== 0 && props.sendData.amount.length !== 0 && ((0, jsx_runtime_1.jsxs)(de_ui_1.Text, { className: checkout_module_css_1.default.topAmountUsd, children: ["~ ", parseFloat((Number(props.sendData.amount) * Number(amountUsd)).toString()).toLocaleString('en-US', {
                                    style: 'currency',
                                    currency: 'USD'
                                })] }))] }), (0, jsx_runtime_1.jsxs)("div", { className: checkout_module_css_1.default.info, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: checkout_module_css_1.default.detailsHeader, children: t('trans-detail.header') }), (0, jsx_runtime_1.jsxs)("div", { className: checkout_module_css_1.default.infoItem, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: checkout_module_css_1.default.infoItemLeft, children: t('trans-detail.address') }), (0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: checkout_module_css_1.default.infoItemRight, children: (0, smlAddr_1.smlAddrCheckout)(props?.sendData?.sendAddress) })] }), (0, jsx_runtime_1.jsx)("div", { className: checkout_module_css_1.default.dottedLine, children: (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "dotted-line" }) }), (0, jsx_runtime_1.jsxs)("div", { className: checkout_module_css_1.default.infoItem, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: `${checkout_module_css_1.default.infoItemLeft} ${tonBalanceTon < feeToken ? checkout_module_css_1.default.errorText : ''}`, tgStyles: { color: tonBalanceTon < feeToken ? '#FF3B30' : 'rgb(var(--placeholder-primary))' }, children: t('trans-detail.fee') }), (0, jsx_runtime_1.jsxs)(de_ui_1.Div, { className: checkout_module_css_1.default.infoItemRight, tgStyles: { color: tonBalanceTon < feeToken ? '#FF3B30' : 'rgb(var(--placeholder-primary))' }, style: { color: tonBalanceTon < feeToken ? '#FF3B30' : '' }, children: ["~ ", feeToken, " TON"] })] }), (0, jsx_runtime_1.jsx)("input", { type: 'text', placeholder: t('common.message'), className: checkout_module_css_1.default.messageInput, value: props.message.value, onChange: e => props.message.change(e.target.value), onFocus: (e) => {
                                e.preventDefault();
                                document.body.style.overflow = 'hidden';
                            } })] })] })) : (
        // <div className={s.passwordBlock} style={{ paddingBottom: props.isTg ? '50px' : '' }}>
        //     {/* <PasswordInput
        //         onChange={e => props.psw.change(e.target.value)}
        //         placeholder={t('common.password')}
        //         inputTitle={t('common.enter-password')}
        //     /> */}
        // </div>
        (0, jsx_runtime_1.jsx)(pinpad_1.PinPad, { title: t('pincod.enter'), onChange: e => props.psw.change(e), animationState: createAnimation, setAnimationState: setCreateAnimation })) }));
};
exports.Checkout = Checkout;
